import { FetchGuestNotificationsQuery } from '@website/types/graphqlOperations';
import { DateTime } from 'luxon';

/**
 *
 * combineGuestAndHostsNotificationsObjects
 *
 * Combines the guest and host notifications objects into a single array so they
 * can be displayed together
 */
export default function combineGuestAndHostsNotificationsObjects(
  usersNotificationsData?: FetchGuestNotificationsQuery['user'],
) {
  if (!usersNotificationsData) {
    return [];
  }
  const totalHostNotifications =
    usersNotificationsData.hostRoles?.items?.flatMap(
      (roles) => roles.host.notifications.items,
    );
  const totalUserNotifications = [
    ...usersNotificationsData.notifications.items,
    ...totalHostNotifications,
  ];
  //   sort notifications by date published
  return totalUserNotifications.sort(
    (a, b) =>
      DateTime.fromISO(b.published).toMillis() -
      DateTime.fromISO(a.published).toMillis(),
  );
}
